import React, { useMemo } from 'react';
import { Table } from 'antd';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import PatientSessionsEmptyState from "../patient/PatientSessionsEmptyState";

export default function SessionList({ sessions, pagination, onPageChange, fromPatientDetails = false }) {
  const { t } = useTranslation();

  const buildSessionLink = (record) => {
    const basePath = `/sessions/${record.getUUID()}`;
    const searchParams = new URLSearchParams();

    if (!record.isReady()) searchParams.set('generating', '1');

    return searchParams.toString() ? `${basePath}?${searchParams.toString()}` : basePath;
  };

  const columns = useMemo(() => [
    {
      title: t('sessions.title'),
      dataIndex: 'gen_title',
      key: 'gen_title',
      render: (text, record) => {
        if (record.isErrored()) return t('sessions.fields.no_note');

        return (
          <Link to={buildSessionLink(record)}>
            {record.getTitle(t, fromPatientDetails)}
          </Link>
        );
      },
      onCell: () => ({ style: { minWidth: 200 } }),
    },
    {
      title: '',
      dataIndex: 'summary',
      key: 'summary',
      responsive: ['lg'],
      render: (text, record) => record.getExcerpt(t),
    },
    {
      title: '',
      dataIndex: 'last_session_date',
      key: 'last_session_date',
      responsive: ['md'],
      render: (text, record) => record.getLastSessionDate(),
      onCell: () => ({ style: { minWidth: 200 } }),
    },
  ], [t]);

  if (sessions.length === 0) return (
    <PatientSessionsEmptyState />
  );

  return (
    <Table
      showHeader={false}
      columns={columns}
      dataSource={sessions}
      rowKey={(record) => record.getUUID()}
      pagination={
        pagination.total > pagination.pageSize
          ? {
            ...pagination,
            position: ['bottomCenter']
         }
          : false
      }
      onChange={(pagination) => onPageChange(pagination.current)}
    />
  );
}